import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import {
  HtmlContent,
  HtmlContentWithIframe,
} from 'hb-react/shared/components/HtmlContent';

const PublicationText = ({ text, noIframes = false, ...props }) => (
  <Wrapper {...props}>
    {noIframes ? (
      <HtmlContent content={text} withEditorStyles />
    ) : (
      <HtmlContentWithIframe content={text} withEditorStyles />
    )}
  </Wrapper>
);

export default PublicationText;

const Wrapper = styled(Box).attrs({
  display: 'block',
  width: '100%',
})`
  ${(props) => sharedStyles(props)}
`;

export const sharedStyles = ({ theme }) => css`
  font-size: 1.1rem;
  line-height: 1.7rem;

  & * {
    font-size: inherit;
    line-height: inherit;
  }

  a {
    font-weight: normal;

    &:hover {
      font-weight: normal;
    }
  }

  // clearfix
  &:after {
    content: '';
    clear: both;
    display: table;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0.5rem;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  blockquote {
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 40px;
    margin-inline-end: 40px;

    padding: 6px 8px 6px 20px;
    border-left: 5px solid #ccc;

    p {
      margin: 0;

      &:not(:last-of-type) {
        margin-bottom: 12px;
      }
    }
  }

  ol {
    list-style-type: decimal;
  }

  ol ol,
  ul ul {
    padding-left: ${theme.space[3]}px;
    margin-bottom: 0;
  }

  ul {
    list-style-type: disc;
  }

  ul,
  ol {
    padding-left: 40px;
    margin-bottom: ${theme.space[5]}px;
  }

  div,
  p,
  iframe {
    max-width: 100%;
  }

  table {
    td,
    th {
      padding: 5px;
    }
  }
`;
